import React from 'react'

export default function RegularUpdates() {
  return (
    <section>
      <h2>Regular Updates</h2>
      <p>
        Our team is constantly working to improve the product by implementing
        new features and enhancing user experience.
      </p>
      <p>
        Stay updated with our ongoing changes and make the most of the latest
        functionalities. If you have feedback or suggestions, feel free to
        contact us through our support channels.
      </p>
    </section>
  )
}
